import { Box, Flex, Grid, GridItem, Text, Badge } from '@chakra-ui/react';
import { Link as ReachLink } from 'react-router-dom';
import { INTERVIEWS } from '../Components/info_all_interviews';
import { INTERVIEW_ENGLISH } from '../Components/interview_english';
import ReviewWarning from '../Components/ReviewWarning';
import { useLanguage } from '../i18n/LanguageContext';
import { getLocalizedMember } from '../i18n/translations';

const InterviewCard = ({ interview }) => {
  const { language, t } = useLanguage();
  if (language === 'en' && INTERVIEW_ENGLISH[interview.id]) {
    interview = { ...interview, ...INTERVIEW_ENGLISH[interview.id] };
  }
  const expert = getLocalizedMember(interview.expert, language);
  return (
    <Box
      as={ReachLink}
      to={`/interview/${interview.id}`}
      display="flex"
      flexDirection="column"
      bg="white"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="sm"
      border="1px solid"
      borderColor="gray.100"
      _hover={{ boxShadow: 'md', textDecoration: 'none' }}
      transition="box-shadow 0.2s"
    >
      {/* Color banner */}
      <Flex
        h="44"
        bgGradient="linear(to-br, #1e646e, #002c2f)"
        align="center"
        justify="center"
        flexDirection="column"
        textAlign="center"
        px={6}
        gap={1}
      >
        <Text fontSize="xs" color="whiteAlpha.700" textTransform="uppercase" letterSpacing="widest">
          {t('interview.label')}
        </Text>
        <Text fontSize="lg" fontWeight="bold" color="white" lineHeight="short">
          {expert.name_ch}
        </Text>
        <Text fontSize="sm" color="whiteAlpha.800">
          {expert.title}<ReviewWarning message={expert.warning} />
        </Text>
      </Flex>

      {/* Body */}
      <Flex flexDirection="column" flex={1} p={5} gap={3}>
        <Text fontSize="xs" color="gray.400">
          {interview.date}
        </Text>

        <Text fontSize="md" fontWeight="bold" color="#1e4f4f" lineHeight="short" noOfLines={2}>
          {interview.title}
        </Text>

        <Text fontSize="sm" color="gray.600" lineHeight="tall" noOfLines={3} flex={1}>
          {interview.intro}
        </Text>

        {/* Tags */}
        <Flex flexWrap="wrap" gap={1.5}>
          {interview.tags.map((tag) => (
            <Badge
              key={tag}
              px={2}
              py={0.5}
              borderRadius="full"
              bg="#edf3f8"
              color="#1e4f4f"
              fontWeight="medium"
              fontSize="xs"
            >
              {tag}
            </Badge>
          ))}
        </Flex>

        <Text fontSize="sm" color="#437070" fontWeight="medium">
          {t('interview.read')}
        </Text>
      </Flex>
    </Box>
  );
};

const InterviewList = () => {
  const { t } = useLanguage();
  return (
    <Box bg="#edf3f8" p={{ base: 5, md: 20 }} minH="100vh">
      <Box maxW="5xl" mx="auto">
        <Box mb={8}>
          <Text fontSize="3xl" fontWeight="extrabold" color="#1e646e" mb={1}>
            {t('nav.interviews')}
          </Text>
          <Text color="gray.500">
            {t('interview.subtitle')}
          </Text>
        </Box>
        <Grid
          templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
          gap={6}
        >
          {INTERVIEWS.filter((interview) => interview.published !== false).map((interview) => (
            <GridItem key={interview.id}>
              <InterviewCard interview={interview} />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default InterviewList;
